import { ChartData } from '../data/ChartData';
import { ChartDataArray } from '../data/ChartDataArray';
import { ColumnBarChartAttrHandler } from './ColumnBarChartAttrHandler';
import { DataRenderer } from './DataRenderer';

export class ParallelColumnBarRenderer extends DataRenderer {
  private breakdownData?: ChartDataArray[];

  constructor(private gElement: d3.Selection<SVGGElement, unknown, null, undefined>) {
    super();
  }

  /**
   * @returns breakdownSeries, grouped by breakdownkey
   */
  protected createBreakdownSeriesParallel(breakdownData: ChartDataArray[]): ChartData[][] {
    this.breakdownData = breakdownData;
    const series = breakdownData.map(breakdownSeries => breakdownSeries.getData());

    return series;
  }

  protected renderInternal(series: any[], handlers: ColumnBarChartAttrHandler) {
    this.gElement
      .append('g')
      .selectAll('g')
      .data(series)
      .enter()
      .append('g')
      .attr('class', (_, i) => 'chart-color-' + i)
      .style('fill', (_, i) => this.breakdownData![i].color || null)
      .attr('transform', handlers.transform!)
      .selectAll('rect')
      .data(d => d)
      .enter()
      .append('rect')
      .attr('width', handlers.width!)
      .attr('height', handlers.height!)
      .attr('x', handlers.x!)
      .attr('y', handlers.y!);
  }

  switchHighlight(_index: number, _highlight: boolean) {}
}
